// extracted by mini-css-extract-plugin
export var container = "ArticleSummary-Rows-module--container--sAinh";
export var title = "ArticleSummary-Rows-module--title--+2lMJ";
export var trim = "ArticleSummary-Rows-module--trim--r9jbx";